module.exports = __webpack_public_path__ + "static/media/data t.f2e42f6b.jpeg";